// extracted by mini-css-extract-plugin
module.exports = {"pane":"_2SzEG3lMLovnF3jmtORQWS--pane","pane_resizing":"y-_VokfxJ0nFn2v7hInEq--pane_resizing","pane_content":"_39WCgtK0AM6MfRfHDuokFT--pane_content"};